// Global footer — visible on every route. Razorpay reviewers crawl multiple
// pages looking for compliance links, so this MUST be reachable everywhere.
import { Link } from "wouter";

const LINKS = [
  { href: "/terms", label: "Terms" },
  { href: "/privacy", label: "Privacy" },
  { href: "/refund", label: "Refund Policy" },
  { href: "/about", label: "About" },
  { href: "/contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="mt-auto border-t border-zinc-900 px-6 sm:px-10 lg:px-20 py-10"
    >
      <div className="max-w-5xl mx-auto flex flex-col items-center gap-4 text-center">
        <nav
          data-testid="footer-nav"
          className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2"
        >
          {LINKS.map((l) => (
            <Link
              key={l.href}
              href={l.href}
              data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-[12px] font-mono uppercase tracking-[0.18em] text-zinc-500 hover:text-amber-300 transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <p className="font-mono text-[11px] text-zinc-600 max-w-xl leading-relaxed">
          © 2026 Super Founder Hub. The Founder Mode Quest by Praveen Singh V.
          <br className="hidden sm:block" />
          <a
            href="mailto:praveen@thefoundermode.in"
            className="hover:text-amber-300"
            data-testid="footer-email"
          >
            praveen@thefoundermode.in
          </a>
          {" · "}
          <span data-testid="footer-phone">+91 94483 10439</span>
        </p>
      </div>
    </footer>
  );
}
